import api from 'api';
import { Review } from 'api/Serializers/Accounts';
import Dashboard from 'components/account/dashboard';
import Callout from 'components/callout';
import Card from 'components/card';
import Loading from 'components/loading';
import { APP_ROOT_URL } from 'config';
import Testimonials from 'containers/reviews';
import { useSnackbar } from 'notistack';
import { CLIENT_ROUTES } from 'pages/account/client/utils';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getAccountDetail, getUsername } from 'state/selectors';

const byCreated = (r1: Review, r2: Review) =>
  r1.created > r2.created ? -1 : 1;

const TestimonialsPage = () => {
  const account = useSelector(getAccountDetail);
  const username = useSelector(getUsername);
  const [reviews, setTestimonials] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getTestimonials = async () => {
    const response = await api.account.reviews(username);
    setTestimonials(response.data.sort(byCreated));
    setIsLoading(false);
  };

  useMemo(() => {
    getTestimonials();
  }, []);

  return (
    <Dashboard title="My testimonials">
      <div className="space-y-4">
        {isLoading ? (
          <Loading message="Getting testimonials..." />
        ) : reviews.length === 0 ? (
          <Card title="No testimonials">
            <Callout type="info">You don't yet have any testimonials!</Callout>
          </Card>
        ) : (
          <>
            <Card maxWidth="3xl">
              <h4 className="font-medium text-md mb-3">
                Your testimonials link for clients:
              </h4>
              <Shortlink slug={account.slug}></Shortlink>
            </Card>
            <Card maxWidth="3xl">
              <Testimonials
                name={`My testimonials`}
                type="testimonials"
                count={reviews.length}
                reviews={reviews}
                truncate={false}
              />
            </Card>
          </>
        )}
      </div>
    </Dashboard>
  );
};

const Shortlink = ({ slug }) => {
  const { enqueueSnackbar } = useSnackbar();
  const reviewsUrl =
    APP_ROOT_URL + CLIENT_ROUTES.INSTRUCTORS.nav(slug, 'review');

  const onCopyClick = () => {
    copyToClipboard(reviewsUrl);
    enqueueSnackbar({
      message: 'Shortlink copied to clipboard!',
      variant: 'success',
    });
  };

  return (
    <div className="flex items-center justify-between p-3 bg-gray-200 border border-gray-200 rounded">
      <div>
        <span className="text-gray-700">{reviewsUrl}/</span>
      </div>
      <div className="absolute right-0 mr-2 center-y">
        <button
          className="px-2 py-1 text-sm bg-white border border-gray-400 border-solid rounded"
          onClick={onCopyClick}
        >
          Copy
        </button>
      </div>
    </div>
  );
};
export default TestimonialsPage;
